import type { Modifier } from "@dnd-kit/core";
import { getEventCoordinates } from "@dnd-kit/utilities";

/** Lift the pill above the thumb so the title stays visible while dragging. */
const MOBILE_DRAG_PILL_LIFT_PX = 32;

/**
 * Keeps the drag overlay centered on the touch/pointer (not the card grab point).
 * Used with the compact mobile pill overlay only.
 */
export const snapMobileDragOverlayToPointer: Modifier = ({
	activatorEvent,
	draggingNodeRect,
	overlayNodeRect,
	transform,
}) => {
	if (!draggingNodeRect || !overlayNodeRect || !activatorEvent) return transform;
	const coordinates = getEventCoordinates(activatorEvent);
	if (!coordinates) return transform;

	const offsetX =
		coordinates.x
		- draggingNodeRect.left
		- draggingNodeRect.width / 2
		+ overlayNodeRect.width / 2;
	const offsetY =
		coordinates.y
		- draggingNodeRect.top
		- draggingNodeRect.height / 2
		+ overlayNodeRect.height / 2
		- MOBILE_DRAG_PILL_LIFT_PX;

	return {
		...transform,
		x: transform.x + offsetX,
		y: transform.y + offsetY,
	};
};
